module.exports = __webpack_public_path__ + "images/social-icons/btn_google_dark_normal_ios-21f60fe4d1b88402ff8aa3d6c5c65571.png";